import {ModuleComponent} from "../../js/module-component";
import Swiper from 'swiper/bundle';

// import Swiper and modules styles
export class ModSlider extends ModuleComponent {
    ready() {
        super.ready();
        this.withoutAutoplay = this.$root.data("without-autoplay");

        this.swiper = new Swiper(this.$root.find('.swiper-container').get(0), {
            direction: 'horizontal',
            pagination: {
                el: this.$root.find('.swiper-pagination').get(0),
                pauseOnMouseEnter: true,
            },
            paginationType: 'bullets',
            navigation: {
                nextEl: this.$root.find('.swiper-button-next').get(0),
                prevEl: this.$root.find('.swiper-button-prev').get(0),
            },
            // AutoPlay
            autoplay: {
                delay: 7000,
                pauseOnMouseEnter: false,
                disableOnInteraction: false
            },
            speed: 800,
            effect: this.$root.data("effect"),
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: 1,
            initialSlide: 0,
            // Loop
            loop: true,
        });

        if (this.withoutAutoplay) {
            console.log(this.withoutAutoplay)
            this.swiper.autoplay.stop();
        } else {
            this.$root.find('.swiper').mouseenter(() => {
                this.swiper.autoplay.stop();
            }).mouseleave(() => {
                this.swiper.autoplay.start();
            });
        }

    }
}
